module.exports = __webpack_public_path__ + "img/ico-cloud-data.85642e00.svg";